module.exports = __webpack_public_path__ + "img/img151_2.16dfa851.png";